import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { circles } from "@/mocks/circles";

const iconBgMap = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

const themeChip = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

const filterTabs = ["全部漫圈", "热门圈子", "创作互助"];

export default function Circles() {
  useSeo(
    "漫圈社区 - 178漫画网同好交流聚集地，按作品和题材划分漫圈",
    "178漫画网漫圈社区，按作品和题材划分漫圈。热血、悬疑、恋爱、科幻、奇幻、国漫等圈子等你加入，随时找到同好交流剧情、分享心得，追漫有人陪聊。",
  );

  const [active, setActive] = useState("全部漫圈");

  const filtered = useMemo(() => {
    if (active === "热门圈子") return circles.filter((c) => c.hot);
    if (active === "创作互助") return circles.filter((c) => c.name.includes("绘技") || c.name.includes("声优"));
    return circles;
  }, [active]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-16 md:pt-20">
        <section className="bg-background-100 border-b border-background-200">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-700">漫圈社区</span>
            </nav>
            <h1 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
              漫圈社区 · 找到你的同好
            </h1>
            <p className="mt-2 max-w-2xl text-sm md:text-base text-foreground-600">
              178漫画网按作品和题材划分漫圈，这里聚集了天南海北的漫友。挑一个圈子进圈看看，从"你也追这部？"开始认识同好。
            </p>
          </div>
        </section>

        <section className="bg-background-50 py-8 md:py-12">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1">
              {filterTabs.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setActive(t)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    active === t ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-primary-700"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {filtered.map((c) => (
                <article key={c.id} className="group flex flex-col rounded-2xl border border-background-200 bg-background-100 p-5 hover:border-primary-300 hover:bg-background-50 transition-all">
                  <div className="flex items-start justify-between">
                    <span className={`grid h-12 w-12 place-items-center rounded-2xl ${iconBgMap[c.theme]} text-background-50 text-xl shadow-sm`}>
                      <i className={c.icon} />
                    </span>
                    {c.hot && (
                      <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                        <i className="ri-fire-fill" /> 热门
                      </span>
                    )}
                  </div>
                  <h2 className="mt-4 font-heading text-lg text-foreground-950">{c.name}</h2>
                  <p className="mt-2 text-sm leading-6 text-foreground-600 flex-1">{c.description}</p>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {c.tags.map((t) => (
                      <span key={t} className={`rounded-full px-2.5 py-0.5 text-xs ${themeChip[c.theme]}`}>#{t}</span>
                    ))}
                  </div>
                  <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-600">
                    <span className="inline-flex items-center gap-1"><i className="ri-user-heart-line text-primary-500" />{c.members} 人</span>
                    <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line" />{c.posts} 帖</span>
                    <button
                      type="button"
                      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                      className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-4 py-1.5 font-medium text-background-50 hover:bg-primary-600 transition-colors"
                    >
                      进圈看看
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}